
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as irLcgFd3wOKYlwWboO8cW2dvE1ATXPaG7u4sQ9Q6K2NBAMeta } from "/frontend/src/pages/ir.vue?macro=true";
import { default as index8kkYUXOi_453YN2IntLIPuM4J0t9tboXuv7_45p23akakh8Meta } from "/frontend/src/pages/index.vue?macro=true";
import { default as companyOnQK_HvnMRpUw_W6xY6ffV2IXBapW2iYEMH3z1zv3nwMeta } from "/frontend/src/pages/company.vue?macro=true";
import { default as contactRGl3AXexsqYVIOkZTJwEnLijYFu_45_45InEv3HDos0bE4YMeta } from "/frontend/src/pages/contact.vue?macro=true";
import { default as indexDWDpVlQQPo3oXEryVj_45RdeJCom9IBWViQf_45Wo4aXq0wMeta } from "/frontend/src/pages/faq/index.vue?macro=true";
import { default as indexpHs_45VGyeOAYmqn4kqPl3D0vDzAR7qOsg1bHdJ9ggVtQMeta } from "/frontend/src/pages/info/index.vue?macro=true";
import { default as terms8HXWzRMKBn5_9hFS9iYqfGvnEaWQxxdxOw07Xboa3EUMeta } from "/frontend/src/pages/info/terms.vue?macro=true";
import { default as privacyzLf46cRyHbrh3J56J9uVwtVg3xlvZxWrc0Khf1nEwgMMeta } from "/frontend/src/pages/info/privacy.vue?macro=true";
import { default as customerbPdbOby5WCEOt_45rKa69gLhPKnXmqAW8JmpDAXjBxX3IMeta } from "/frontend/src/pages/info/customer.vue?macro=true";
import { default as policy_45salesJ_5nDqdsew8JZil_45gixf0wnRc8LCKt2_45Oufxx6rn3eYMeta } from "/frontend/src/pages/info/policy-sales.vue?macro=true";
import { default as sentry_45error_45testBqKshr6KVVQkDUAELECnvovGswqW0NCDcIuI0qpEU2kMeta } from "/frontend/src/pages/sentry-error-test.vue?macro=true";
import { default as indexh4aOjwZfHyVNR5hQ91MuukL7PlxqZiJhNnP4fELabrEMeta } from "/frontend/src/pages/fire/compare/index.vue?macro=true";
import { default as invite_45policyRRCUAPPgWQ3wHf4MLBtDCLh_45sRdgVeQdNwTCwERUr8cMeta } from "/frontend/src/pages/info/invite-policy.vue?macro=true";
import { default as privacy_45policyjrAbhBXPhCgT19nLamWcMe5cNBTNad0P4e3iGuJ1JxMMeta } from "/frontend/src/pages/info/privacy-policy.vue?macro=true";
import { default as index_C9WFgknNhcyvDL5t_45zMex3mQdV8mfpKrh5GXECkv1sMeta } from "/frontend/src/pages/fire/preview-compare/index.vue?macro=true";
export default [
  {
    name: "ir",
    path: "/ir",
    component: () => import("/frontend/src/pages/ir.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/frontend/src/pages/index.vue")
  },
  {
    name: "company",
    path: "/company",
    component: () => import("/frontend/src/pages/company.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/frontend/src/pages/contact.vue")
  },
  {
    name: "faq",
    path: "/faq",
    component: () => import("/frontend/src/pages/faq/index.vue")
  },
  {
    name: "info",
    path: "/info",
    component: () => import("/frontend/src/pages/info/index.vue")
  },
  {
    name: "info-terms",
    path: "/info/terms",
    component: () => import("/frontend/src/pages/info/terms.vue")
  },
  {
    name: "info-privacy",
    path: "/info/privacy",
    component: () => import("/frontend/src/pages/info/privacy.vue")
  },
  {
    name: "info-customer",
    path: "/info/customer",
    component: () => import("/frontend/src/pages/info/customer.vue")
  },
  {
    name: "info-policy-sales",
    path: "/info/policy-sales",
    component: () => import("/frontend/src/pages/info/policy-sales.vue")
  },
  {
    name: "sentry-error-test",
    path: "/sentry-error-test",
    component: () => import("/frontend/src/pages/sentry-error-test.vue")
  },
  {
    name: "fire-compare",
    path: "/fire/compare",
    component: () => import("/frontend/src/pages/fire/compare/index.vue")
  },
  {
    name: "info-invite-policy",
    path: "/info/invite-policy",
    component: () => import("/frontend/src/pages/info/invite-policy.vue")
  },
  {
    name: "info-privacy-policy",
    path: "/info/privacy-policy",
    component: () => import("/frontend/src/pages/info/privacy-policy.vue")
  },
  {
    name: "fire-preview-compare",
    path: "/fire/preview-compare",
    component: () => import("/frontend/src/pages/fire/preview-compare/index.vue")
  }
]